import { useContext, useEffect, useState } from "react";
import actions from "./actions";
import { BlocksValue } from "../contexts/blocks";
import { PageValue } from "../contexts/page";
import { WorkflowsValue } from "../contexts/workflows";
import useUtilityActions from "./useutilityactions";
const getUnique = (array) => {
  const _arr = [];
  array.forEach((x) => {
    if (!_arr.includes(x)) {
      _arr.push(x);
    }
  });
  return _arr;
};

export default function () {
  const blocks = useContext(BlocksValue);
  const tree = useContext(PageValue);
  const { workflows } = useContext(WorkflowsValue);
  const [_actions, setActions] = useState([]);
  const utilityActions = useUtilityActions();
  useEffect(() => {
    if (tree && blocks) {
      const elemActions = [];
      const customActions = [];

      const getElementActions = (block) => {
        const schema = blocks.find((x) => x.name === block.component);
        if (!schema) {
          return;
        }
        const exists = elemActions.find((x) => x.block === schema.name);
        if (schema.actions && !exists) {
          schema.actions.forEach((a) => {
            elemActions.push({
              ...a,
              type: "Page",
              block: schema.name,
            });
          });
        }
        block.children.forEach((b) => {
          getElementActions(b);
        });
      };

      const getCustomActions = (block) => {
        const schema = blocks.find((x) => x.name === block.component);
        if (!schema) {
          return;
        }
        if (block.customEvents) {
          console.log(block);
          console.log("CUSTOM EVENTS!", block.customEvents);
          Object.values(block.customEvents).forEach((value) => {
            customActions.push({
              displayName: `Trigger "${value.displayName}"`,
              name: "props.events." + value.name,
              type: "Custom",
              props: [],
            });
          });
        }
      };

      const getCustomWorkflows = () => {
        console.log("workflows ", workflows);
        Object.values(workflows).forEach((wf) => {
          customActions.push({
            displayName: `Trigger "${wf.name}"`,
            name: wf.id,
            type: "Custom",
            props: wf.params
              ? wf.params.map((param) => {
                  return {
                    name: param.id,
                    displayName: param.name,
                    editor: "dynamic",
                    editorParams: { type: param.type, list: param.list },
                  };
                })
              : [],
          });
        });
      };

      getElementActions(tree);
      getCustomActions(tree);
      getCustomWorkflows();
      setActions([
        ...actions,
        ...elemActions,
        ...customActions,
        ...utilityActions,
      ]);
    }
  }, [tree, blocks, utilityActions, workflows]);

  return {
    actions: _actions,
    types: getUnique(_actions.map((x) => x.type)),
  };
}
